<div id="section">
  <div class="breadcrumb">
    <span class="breadcrumb-previous" (click)="goTo('home')">Home</span> >
    <span class="breadcrumb-previous" (click)="goTo('landing')">Gestione Prenotazioni</span> >
    <span class="breadcrumb-current">Estrazione Prenotazioni</span>
  </div>
  <div class="my-row">
    <mat-form-field class="my-form-field-color my-row-element-3" appearance="fill">
      <mat-label>Seleziona la nave</mat-label>
      <mat-select [(ngModel)]="selectedShip" name="shipSelect" (selectionChange)="onShipSelected()">
        @for (ship of availableShips; track ship.id_ship) {
          <mat-option [value]="ship">{{ ship.ship_name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="my-form-field-color my-row-element-3" appearance="fill" style="margin-left: 10px">
      <mat-label>Seleziona l'evento di interesse</mat-label>
      <mat-select [(ngModel)]="eventSelected" name="typeSelect" [disabled]="!selectedShip">
        @for (item of allEvents; track item.id_selector) {
          <mat-option [value]="item">{{ item.name_selector }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      class="my-form-field-color my-row-element-3"
      appearance="fill" style="margin-left: 10px"
    >
      <mat-label>Inserisci data da - a</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [disabled]="!selectedShip">
        <input matStartDate formControlName="start" placeholder="Da" />
        <input matEndDate formControlName="end" placeholder="A" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <div class="my-row-element-3" style="margin-bottom: 15px;">
      <button
        class="my-button confirm"
        mat-raised-button
        [disabled]="isSearchDisabled()"
        (click)="search()"
      >
        Cerca
      </button>
    </div>
  </div>
  @if (viewReservations) {
    <div class="mat-elevation-z8 my-following-row">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="nome_evento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Evento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.event_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="data_prenotazione">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Data/Ora Prenotazione
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.creation_datetime }}
          </td>
        </ng-container>
        <ng-container matColumnDef="data_evento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Data/Ora Evento
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.occurrence_datetime }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nome_passeggero">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Nome Passeggero
          </th>
          <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
        </ng-container>
        <ng-container matColumnDef="numero_prenotazione">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Numero di Prenotazione
          </th>
          <td mat-cell *matCellDef="let element">{{ element.booking_number }}</td>
        </ng-container>
        <ng-container matColumnDef="numero_badge">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Numero di Badge
          </th>
          <td mat-cell *matCellDef="let element">{{ element.badge_number }}</td>
        </ng-container>
        <ng-container matColumnDef="numero_cabina">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Numero Cabina</th>
          <td mat-cell *matCellDef="let element">{{ element.id_cabin }}</td>
        </ng-container>
        <ng-container matColumnDef="numero_partecipanti">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Partecipanti</th>
          <td mat-cell *matCellDef="let element">
            {{ element.number_of_users }}
          </td>
        </ng-container>
        <ng-container matColumnDef="check_in">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Check-in</th>
          <td mat-cell *matCellDef="let element">{{ element.has_checkin }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Stato prenotazione
          </th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="10">
            Nessun dato disponibile per l'evento selezionato.
          </td>
        </tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  }
  <div class="my-button-container">
    @if (btnDownload) {
      <button class="my-button confirm" mat-raised-button (click)="downloadFile()">
        <span class="myspan">Scarica Report        
          <img src="./assets/file_download_white_24dp.svg" style="margin-left: 20px"  alt=""/>
        </span>
      </button>
    }
  </div>
</div>
